import React from "react";
import { default as MUITableCell } from "@mui/material/TableCell";
import styled from "styled-components";

const StyledMUITableCell = styled(MUITableCell)``;

export const TableCell = (props) => {
  return <StyledMUITableCell {...props} />;
};
